let URL = `https://booking.smartrak.co.nz`;
let APP_SITE_URL = `https://app.smartrak.co.nz`;
let BOOKING_API_URL = `https://api.smartrak.co.nz/booking`;

if (process.env.NODE_ENV !== `production`) {
    URL = `http://localhost:8181`;
    APP_SITE_URL = `https://app-test.smartrak.co.nz`;
    BOOKING_API_URL = `https://api-test.smartrak.co.nz/booking`;
    // BOOKING_API_URL = `http://localhost:62579/58304`; // To run with local api, swap this in
}

export { URL, APP_SITE_URL, BOOKING_API_URL };

export const FETCH_INITIAL_DATA = `FETCH_INITIAL_DATA`;
export const RECEIVED_ENTITIES = `RECEIVED_ENTITIES`;
export const RESTART_POLL = `RESTART_POLL`;
export const FETCH_UNAVAILABLE_TIMES = `FETCH_UNAVAILABLE_TIMES`;
export const SET_UNAVAILABLE_TIMES = `SET_UNAVAILABLE_TIMES`;
export const SET_LOGGED_IN = `SET_LOGGED_IN`;
export const LOGOUT = `LOGOUT`;
export const RECEIVED_AUTHED_USER = `RECEIVED_AUTHED_USER`;
export const SET_ERROR = `SET_ERROR`;
export const CLEAR_ERROR = `CLEAR_ERROR`;
export const LOADING_UPDATED = `LOADING_UPDATED`;
export const LOADING_FINISHED = `LOADING_FINISHED`;
export const CANCEL_BOOKING = `CANCEL_BOOKING`;
export const CHECK_OUT_BOOKING = `CHECK_OUT_BOOKING`;
export const CHECK_IN_BOOKING = `CHECK_IN_BOOKING`;
export const EDIT_BOOKING_TIME_CLICKED = `EDIT_BOOKING_TIME_CLICKED`;
export const BOOKING_UPDATED = `BOOKING_UPDATED`;
export const SET_SNACKBAR = `SET_SNACKBAR`;
export const CLEAR_SNACKBAR = `CLEAR_SNACKBAR`;
export const UPDATE_BOOKING_TIMES = `UPDATE_BOOKING_TIMES`;
export const RECEIVED_PERSON = `RECEIVED_PERSON`;

export const SET_NEW_BOOKING_START_DATE = `SET_NEW_BOOKING_START_DATE`;
export const SET_NEW_BOOKING_START_TIME = `SET_NEW_BOOKING_START_TIME`;
export const SET_NEW_BOOKING_END_TIME = `SET_NEW_BOOKING_END_TIME`;
export const SET_NEW_BOOKING_PICKUP_LOCATION = `SET_NEW_BOOKING_PICKUP_LOCATION`;
export const SET_NEW_BOOKING_JOURNEY_TO_LOCATION = `SET_NEW_BOOKING_JOURNEY_TO_LOCATION`;
export const SET_NEW_BOOKING_TRAVEL_REASON = `SET_NEW_BOOKING_TRAVEL_REASON`;
export const SET_NEW_BOOKING_CUSTOM_TRAVEL_REASON = `SET_NEW_BOOKING_CUSTOM_TRAVEL_REASON`;
export const SET_NEW_BOOKING_CUSTOM_JOURNEY_TO_LOCATION = `SET_NEW_BOOKING_CUSTOM_JOURNEY_TO_LOCATION`;
export const SET_NEW_BOOKING_COST_CENTRE = `SET_NEW_BOOKING_COST_CENTRE`;
export const SET_NEW_BOOKING_PLANT = `SET_NEW_BOOKING_PLANT`;
export const SET_NEW_BOOKING_PLANT_TYPE = `SET_NEW_BOOKING_PLANT_TYPE`;
export const FETCH_AVAILABLE_PLANT = `FETCH_AVAILABLE_PLANT`;
export const FETCH_AVAILABLE_PLANT_TYPES = `FETCH_AVAILABLE_PLANT_TYPES`;
export const SET_AVAILABLE_PLANT = `SET_AVAILABLE_PLANT`;
export const SET_NEW_BOOKING_PRIVATE_USE = `SET_NEW_BOOKING_PRIVATE_USE`;
export const SET_NEW_BOOKING_INITIAL_STATE = `SET_NEW_BOOKING_INITIAL_STATE`;
export const CREATE_BOOKING = `CREATE_BOOKING`;

export const DATE_TIME_FORMAT = `YYYY-MM-DD[T]HH:mm:ss.SSS`;



// WEBPACK FOOTER //
// ./scripts/constants/index.js